import { Text } from '@chakra-ui/react';
import { AppTheme } from '../../../ui/theming/valuobject/app-theme.ts';
import PageLayout from '../../../ui/component/layout/page-layout.tsx';
import { useLingui } from '@lingui/react/macro';

interface ErrorPageProps {
  title: string;
  errorText: string;
}

/**
 * Rendert eine Fehlerseite mit einem Titel und einer Fehlermeldung.
 */
export default function ErrorPage({ title, errorText }: ErrorPageProps) {
  const { t } = useLingui();

  return (
    <PageLayout title={t`Unexpected Error`}>
      <Text fontSize={AppTheme.FontSize.PX_28} fontWeight={AppTheme.FontWeight.WEIGHT_500}>
        {title}
      </Text>
      <Text>{errorText}</Text>
    </PageLayout>
  );
}
